import React from "react";
import { Navigate } from "react-router-dom";
import { isEmpty } from "lodash";

// Libraries
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

const Home = ({ isLoggedIn, companyId, defaultMenu }) => {
	const routePath = !isLoggedIn ? "/auth" : companyId === 0 ? "/chooseCompany" : isEmpty(defaultMenu) ? "/monitor" : defaultMenu.path;
	return <Navigate to={routePath} replace />;
};

Home.propTypes = {
	isLoggedIn: PropTypes.bool,
	companyId: PropTypes.number,
	defaultMenu: PropTypes.object,
};

function mapStateToProps({ user, company }) {
	return {
		isLoggedIn: user.isLoggedIn,
		defaultMenu: user.defaultMenu,
		companyId: company.companyId,
		settings: company.settings,
	};
}

export default connect(mapStateToProps)(Home);
